<template>
    <div class="card card-service">
      <div class="card-service-main">
        <div class="card-service-title">
          <h3 class="service-title mb-0">
            <a :href="serviceDetails.getUrl()">{{ capitalizeFirstLetter(serviceDetails.getName()) }}</a>
          </h3>
          <div class="service-mode" v-if="mode">{{ capitalizeFirstLetter(mode) }}</div>

        </div>
        <p class="info" v-if="serviceDetails.getSupportedMode() || serviceDetails.getServiceKind()">
          <i class="icon icon-home" aria-hidden="true"></i>
            <span>
              <span v-if="serviceDetails.getSupportedMode()">
                {{ serviceDetails.getSupportedMode() }}
              </span>
              <br v-if="serviceDetails.getSupportedMode() && serviceDetails.getServiceKind()"/>
              <span v-if="serviceDetails.getServiceKind()">
                {{ serviceDetails.getServiceKind() }}
              </span>
            </span>
        </p>
        <p class="info organization" v-if="serviceDetails.getOrganization()">
          <span class="sr-only">Organisation</span>
          <i class="icon icon-cards_organisation" aria-hidden="true"></i>
          {{ serviceDetails.getOrganization() }}
        </p>
        <p class="info public" v-if="serviceDetails.getSupportedPublic()">
          <span class="sr-only">Public</span>
          <i class="icon icon-cards_public" aria-hidden="true"></i>
          {{ serviceDetails.getSupportedPublic() }}
        </p>
        <p class="info partientele" v-if="serviceDetails.getPatientele()">
          <span class="sr-only">Patientèle</span>
          <i class="icon icon-user-nc" aria-hidden="true"></i>
          {{ serviceDetails.getPatientele() }}
        </p>
        <p class="info type" v-if="serviceDetails.getUnitType()">
          <span class="sr-only">Activités</span>
          <i class="icon icon-cards_activites" aria-hidden="true"></i>
          {{ serviceDetails.getUnitType() }}
        </p>
        <p class="info" v-if="serviceDetails.getActiveLabels().length">
          <span class="sr-only">Informations</span>
          <i class="icon icon-cards_label" aria-hidden="true"></i>
          <ul class="resetul">
            <li v-for="(label, i) in serviceDetails.getActiveLabels()" :key="i">
              {{label.name}}
            </li>
          </ul>
        </p>
      </div>
      <div class="card-service-footer" v-if="serviceDetails.getPhones().length">
        <p class="phone">
          <span v-for="(phone, idx) in serviceDetails.getPhones()" :key="phone">
            <a :href="`tel:${ phone.replaceAll(' ', '') }`" :aria-label="`Appeler le ${ phone }`">
              {{ phone }}
            </a>
            <span v-if="idx !== serviceDetails.getPhones().length - 1" style="margin: 0 5px">/</span>
          </span>
        </p>
      </div>
    </div>
</template>
<script>
import { ServiceContentModel } from '@/models';
import { capitalizeFirstLetter } from '@/helpers';

export default {
  props: {
    serviceDetails: {
      type: ServiceContentModel,
      default: () => new ServiceContentModel(),
    },
    mode: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      capitalizeFirstLetter,
    };
  },
};
</script>
